import { createFileRoute } from "@tanstack/react-router";

import { Navigate } from "@/lib/router-compat";
export const Route = createFileRoute("/admin/ai-monitoring")({
  component: () => <Navigate to="/admin/platform-monitor" replace />,
});
